import { initializeApp } from 'firebase/app';
import { getAuth, setPersistence, browserLocalPersistence } from 'firebase/auth';
import { getDatabase } from 'firebase/database';

const firebaseConfig = {
  apiKey: "AIzaSyAozleUIU4X-trlC3bEGPp3-F-0HNuJUxE",
  authDomain: "rideshare-ac798.firebaseapp.com",
  databaseURL: "https://rideshare-ac798-default-rtdb.firebaseio.com",
  projectId: "rideshare-ac798",
  storageBucket: "rideshare-ac798.firebasestorage.app",
  messagingSenderId: "206152624373",
  appId: "1:206152624373:web:f209aeead08e67164f3dbc"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getDatabase(app);

setPersistence(auth, browserLocalPersistence).catch((error) => {
  console.log('Auth persistence error:', error);
});